import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Statute } from './statute.interface';

export class StatuteService {
   async getStatutes() {
      const response = await http.get<ApiResource<Array<Statute>>>(`/statutes`, {
         ...cacheFirstConfig,
      });
      return response.data;
   }

   async getStatute() {
      throw Error('Method not implemented');
   }

   async postStatute() {
      throw Error('Method not implemented');
   }

   async putStatute() {
      throw Error('Method not implemented');
   }

   async deleteStatute() {
      throw Error('Method not implemented');
   }
}
